const introText = `
1500 Chicken Fighters NFTs living in the Solana blockchain. 
$KAI X Utility X Chicken Breeding.
`;

export default introText;
